<!-- 🔧 FIX 2026-02-10: Masquer les accordéons GR-Unpublish (toujours vides) -->
<ng-container *ngIf="!isGrUnpublish()">
<div class="action-container">
  <app-action-field class="action-field"
                    [isRepeatable]="isRepeatable"
                    [isDeletable]="isDeletable"
                  (addSomething)="createSomething()"
                  (deleteSomething)="removeSomething()">
</app-action-field>
</div>
<div id="accordionGroup" class="accordion">
  <h3 class="accordion-container">
    <button type="button" aria-expanded="true" class="accordion-trigger" [attr.aria-controls]="'sect-'+getUniqueAccordionId()" [attr.id]="getUniqueAccordionId()" >
      <span class="accordion-title" [attr.id]="prefixId+'|'+elementId">
        {{getAccordionTitle()}}
        <span class="accordion-icon"></span>
      </span>
    </button>
    <mat-icon *ngIf="infoBulle" matTooltip="Informations" (click)="getEvent($event)" aria-hidden="false" class="info-icon">
      info
    </mat-icon>
  </h3>
  <div [attr.id]="'sect-'+getUniqueAccordionId()" role="region" [attr.aria-labelledby]="getUniqueAccordionId()" class="content">
    <div>
      <fieldset>
        <legend></legend>
        <ng-content></ng-content>
      </fieldset>
    </div>
  </div>
</div>
</ng-container>


